/* template */
<template minapp="mpx" xlang="wxml"><div class="mpx-root-view"><es-layout custom-class="custom-class" navbarTitle="身份核验" :layout="(['header', 'footer'])" :navbarStyle="(navbarStyle)" :esMainStyle="(esMainStyle)" :leftArrow="(true)"><div class="verify-main"><mpx-image mode="widthFix" :style='["width: 100%; box-sizing: border-box;\n    padding: 10px 17px;"] | transRpxStyle' src="https://img-hxy021.didistatic.com/static/starimg/img/v2R6EbgP101683717815365.png"/><div class="verify-indentity-card">为完善铁路实名购票，铁路局自2014年3月1日起对12306本人和其他乘客进行身份信息核验</div><order-title-card title="身份核验未通过？" :customStyle="(customStyle)"><div class="verify-tips verify-tips__title">核验方法</div><div class="verify-tips verify-tips__subtitle">1.请修改乘客身份信息与证件原件完全一致后，重新添加乘车人</div><div class="verify-tips verify-tips__subtitle">2.如还未通过，请持该 12306 账号注册人的证件原件及未核验通过乘客的购票证件原件至车站窗口办理核验</div></order-title-card></div></es-layout><es-toast id="es-toast"/></div></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"m1a3befde"}'>
  @import '~@/mixins/stylus/color.styl'

  .verify-main
    padding 0 12px
    background-repeat no-repeat
    background-size 100vw
    background-image url('https://img-hxy021.didistatic.com/static/starimg/img/GhAT99OZEA1683711738840.png')
    background linear-gradient(to bottom, #1473FF, #F0F1F4)
  .verify-indentity-card
    font-size 12px
    margin-top -10px
    background #FFF4EE
    display flex
    padding 12px 16px
    color #FF7D41
    border-radius 8px
    font-family PingFangSC-Regular
  .verify-tips
    font-size 12px
    color #333333
    font-family PingFangSC-Regular
    &__title
      font-weight bold
      color #1473FF
      margin-bottom 6px
      font-family PingFangSC-Semibold
    &__subtitle
      font-size 14px
      font-weight 400
      white-space pre-line
      margin-top 8px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m1a3befde"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./passenger-identity-verify-page.mpx.js?isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./passenger-identity-verify-page.mpx?ctorType=page&index=0&isPage&mpx&type=script")
  const currentOption = global.__mpxOptionsMap["m1a3befde"]
  export default processOption(
    currentOption,
    "page",
    "",
    "",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-toast':getComponent(require("../../../node_modules/@didi/es-mpx-ui/lib/toast/index.mpx?isComponent&outputPath=components%2Findex68e47551%2Findex")),'order-title-card':getComponent(require("../../components/order-title-card/index.mpx?isComponent&outputPath=components%2Findex0448d4b8%2Findex")),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
